module.exports = __webpack_public_path__ + "static/media/Whistle_Icons_Dec2019_DYK.0deaffee.png";